/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbChangementClasseGridDto } from './FcbChangementClasseGridDto';
import {
    FcbChangementClasseGridDtoFromJSON,
    FcbChangementClasseGridDtoFromJSONTyped,
    FcbChangementClasseGridDtoToJSON,
} from './FcbChangementClasseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbChangementClasseGridDtoPaginatedResults
 */
export interface FcbChangementClasseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbChangementClasseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbChangementClasseGridDto>}
     * @memberof FcbChangementClasseGridDtoPaginatedResults
     */
    results?: Array<FcbChangementClasseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbChangementClasseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbChangementClasseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbChangementClasseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbChangementClasseGridDtoPaginatedResultsFromJSON(json: any): FcbChangementClasseGridDtoPaginatedResults {
    return FcbChangementClasseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbChangementClasseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbChangementClasseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbChangementClasseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbChangementClasseGridDtoPaginatedResultsToJSON(value?: FcbChangementClasseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbChangementClasseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

